"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispatchKevelAnalyticsEvent = exports.dispatchCitrusAnalyticsEvent = void 0;
const dispatchCitrusAnalyticsEvent = (detail) => {
    if ((document === null || document === void 0 ? void 0 : document.body) &&
        detail &&
        detail.action &&
        detail.type &&
        detail.adId &&
        detail.campaignName) {
        document.body.dispatchEvent(new CustomEvent("dataStateChange", { detail }));
    }
};
exports.dispatchCitrusAnalyticsEvent = dispatchCitrusAnalyticsEvent;
const dispatchKevelAnalyticsEvent = (detail) => {
    if ((document === null || document === void 0 ? void 0 : document.body) &&
        detail &&
        detail.action &&
        detail.type &&
        detail.adId &&
        detail.clickUrl &&
        detail.impressionUrl) {
        document.body.dispatchEvent(new CustomEvent("dataStateChange", { detail }));
    }
};
exports.dispatchKevelAnalyticsEvent = dispatchKevelAnalyticsEvent;
